import { initializeApp } from 'firebase/app'
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from 'firebase/auth'
import { getFirestore, doc, getDoc, setDoc, addDoc, updateDoc, collection, getDocs, query, orderBy, arrayUnion, serverTimestamp } from 'firebase/firestore'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
export const db = getFirestore(app)

const googleProvider = new GoogleAuthProvider()

export const loginWithGoogle = async () => {
  const result = await signInWithPopup(auth, googleProvider)
  await ensureUserDocGitcraft(result.user)
  return result.user
}

export const loginWithEmail = async (email, password) => {
  const result = await signInWithEmailAndPassword(auth, email, password)
  await ensureUserDocGitcraft(result.user)
  return result.user
}

export const registerWithEmail = async (email, password) => {
  const result = await createUserWithEmailAndPassword(auth, email, password)
  await ensureUserDocGitcraft(result.user)
  return result.user
}

export const logout = () => signOut(auth)

export const onAuthChange = (callback) => onAuthStateChanged(auth, callback)

export const getUserData = async (uid) => {
  const snap = await getDoc(doc(db, 'users', uid))
  return snap.exists() ? snap.data() : null
}

/**
 * GitCraft 用のユーザードキュメントを作成または更新。
 * - 新規: planGit:'free', sources:['gitcraft'] で作成
 * - 既存: sources に 'gitcraft' を追加（ArchiCraft ユーザーが来た場合など）
 */
const ensureUserDocGitcraft = async (user) => {
  const ref = doc(db, 'users', user.uid)
  const snap = await getDoc(ref)
  if (!snap.exists()) {
    await setDoc(ref, {
      email: user.email,
      planGit: 'free',
      sources: ['gitcraft'],
      createdAt: serverTimestamp(),
    })
  } else {
    await updateDoc(ref, {
      sources: arrayUnion('gitcraft'),
    })
  }
}

export const submitInquiry = async ({ name, email, subject, message }) => {
  await addDoc(collection(db, 'inquiries'), {
    name: name || '',
    email,
    subject: subject || 'GitCraft お問い合わせ',
    message,
    status: 'new',
    app: 'gitcraft',
    createdAt: serverTimestamp(),
  })
}

export const getInquiries = async () => {
  const q = query(collection(db, 'inquiries'), orderBy('createdAt', 'desc'))
  const snap = await getDocs(q)
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }))
}

export const updateInquiryStatus = async (id, status) => {
  await updateDoc(doc(db, 'inquiries', id), { status })
}
